import { render, staticRenderFns } from "./NewSpeedMap.vue?vue&type=template&id=36710976&scoped=true&"
import script from "./NewSpeedMap.vue?vue&type=script&lang=js&"
export * from "./NewSpeedMap.vue?vue&type=script&lang=js&"
import style0 from "./NewSpeedMap.vue?vue&type=style&index=0&id=36710976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36710976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VChip})
